import script from "./DeploymentChannelsInlineSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DeploymentChannelsInlineSelector.vue?vue&type=script&setup=true&lang=js"

import "./DeploymentChannelsInlineSelector.vue?vue&type=style&index=0&id=a19634f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a19634f6"]])

export default __exports__